import React from 'react';
import SEO from '../components/SEO';

const Home = () => {
  const serviceCards = [
    { id: 'darbostogos', title: 'Darbostogos', image: '/img/5.jpg' },
    { id: 'sventes', title: 'Šventės', image: '/img/6.jpg' },
    { id: 'stovyklos', title: 'Stovyklos', image: '/img/7.jpg' },
    { id: 'pirties-namukas', title: 'Pirties namukas', image: '/img/8.jpg' },
  ];

  const galleryImages = [
    { id: 1, src: '/img/9.jpg', alt: 'Family outdoors' },
    { id: 2, src: '/img/10.jpg', alt: 'People in nature' },
    { id: 3, src: '/img/11.jpg', alt: 'Pool and spa' },
    { id: 4, src: '/img/12.jpg', alt: 'Outdoor dining' },
  ];


  return (
    <div>
      <SEO 
        title="Pagrindinis"
        description="Sporto Krantas - pramogų ir poilsio centras gamtos apsuptyje. Darbostogos, šventės, stovyklos, pirties namukas. Rezervuokite savo gyvenimo šventei datą!"
        keywords="sporto krantas, poilsis gamtoje, pramogų centras, darbostogos, šventės, stovyklos, pirtis, Lietuva"
        canonicalUrl="https://sportokrantas.lt/"
      />
      {/* Hero Section - White background */}
      <section className="bg-white border-b-[3px] border-black">
        <div className="flex flex-col lg:flex-row">
          {/* Left - Main Image with CTA (takes ~60% width) */}
          <div className="lg:w-[58%] flex flex-col">
            {/* Hero image with text overlay */}
            <div className="relative flex-1">
              <div className="h-full min-h-[300px] lg:min-h-[500px] overflow-hidden">
                <img 
                  src="/img/13.jpg" 
                  alt="Sporto Krantas" 
                  className="w-full h-full object-cover"
                />
              </div>
              
              {/* Text Overlay - Desktop only (on image) */}
              <div className="hidden lg:block absolute bottom-0 left-0 p-10">
                <h1 className="text-white leading-tight tracking-wide drop-shadow-lg" style={{ fontSize: '29.5px', fontWeight: 700, WebkitTextStroke: '0.5px' }}>
                  KUR LAIKAS PALIEKA<br />PĖDSAKĄ
                </h1>
              </div>
            </div>

            {/* Title - Mobile only (below image with proper spacing) */}
            <div className="lg:hidden bg-white px-6 py-8">
              <h1 className="text-black leading-tight tracking-wide" style={{ fontSize: '29.5px', fontWeight: 700, WebkitTextStroke: '0.5px' }}>
                KUR LAIKAS PALIEKA<br />PĖDSAKĄ
              </h1>
            </div>

            {/* Reservation CTA - white bar below image */}
            <div className="bg-white border-t border-gray-200 px-6 lg:px-0">
              <div className="flex items-stretch">
                <div className="flex-1 flex items-center lg:px-10 py-6 lg:py-5">
                  <span className="text-gray-800 text-sm lg:text-base font-medium">Rezervuok savo gyvenimo šventei datą</span>
                </div>
                <a href="/rezervacija" className="aspect-square bg-black flex items-center justify-center hover:bg-gray-800 transition-colors flex-shrink-0 px-6">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* Right - Service Cards Grid (takes ~40% width) */}
          <div className="lg:w-[42%] grid grid-cols-2 gap-3 p-3 lg:p-4">
            {serviceCards.map((card) => (
              <a
                key={card.id}
                href={`/${card.id}`}
                className="relative overflow-hidden group aspect-square lg:aspect-auto"
              >
                {/* Service image */}
                <div className="w-full h-full min-h-[200px] lg:min-h-0">
                  <img 
                    src={card.image} 
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                
                {/* Card Label - BLACK background */}
                <div className="absolute bottom-3 left-3 right-3 lg:bottom-4 lg:left-4 lg:right-4">
                  <div className="bg-black text-white px-3 py-2 lg:px-4 lg:py-2 flex items-center justify-between group-hover:bg-gray-800 transition-colors">
                    <span className="font-medium text-xs lg:text-sm">{card.title}</span>
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* About Section - Gold background with black borders */}
      <section id="about" className="py-16 border-b-[3px] border-black" style={{ backgroundColor: '#D0AB64' }}>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-black mb-8 tracking-wide" style={{ fontSize: '29.5px', fontWeight: 700, WebkitTextStroke: '0.5px' }}>
              APIE MUS
            </h2>
            
            <div className="space-y-1 text-black leading-relaxed max-w-4xl mx-auto">
              <p>
                Pramogų ir poilsio centras „Sporto krantas" įsikūręs gamtos ir Ilgo ežero apsuptyje. Vos 45 km nuo Vilniaus jūsų laukia gaivus oras, kerintis gamtos grožis, privatumas, ramybė.
              </p>
              <p>
                Mūsų misija – sukurti vietą, kurioje tiesiog gera būti, kurioje kiekvienas galėtų rasti balansą tarp ramaus buvimo gamtoje ir aktyvaus laisvalaikio.
              </p>
              <p>
                Erdvė skirta įmonių renginiams, verslo grupių susitikimams, konferencijoms, vestuvėms ar kitoms asmeninėms šventėms.
              </p>
            </div>
          </div>

          {/* Gallery Images - varying heights */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {galleryImages.map((img) => (
              <div key={img.id} className="aspect-[3/4] overflow-hidden">
                <img 
                  src={img.src} 
                  alt={img.alt}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Social Section */}
      <section className="py-4 bg-white border-b-[3px] border-black">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
            <span className="text-black font-medium tracking-widest text-sm">SEK SPORTO KRANTO NAUJIENAS</span>
            <div className="flex space-x-3">
              {/* Facebook */}
              <a href="https://www.facebook.com/btsportokrantas/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 border-2 border-black rounded-full flex items-center justify-center text-black hover:bg-black hover:text-white transition-colors">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              {/* Instagram */}
              <a href="https://www.instagram.com/sporto_krantas/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 border-2 border-black rounded-full flex items-center justify-center text-black hover:bg-black hover:text-white transition-colors">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              {/* LinkedIn */}
              <a href="https://www.linkedin.com/company/sporto-krantas/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 border-2 border-black rounded-full flex items-center justify-center text-black hover:bg-black hover:text-white transition-colors">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Verta Žinoti Section - Dark background */}
      <section className="border-b-[3px] border-black" style={{ backgroundColor: '#111315' }}>
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-10">
            {/* Content - 70% */}
            <div className="lg:col-span-7 px-8 py-12 lg:py-16 lg:px-12 text-center">
              <h2 className="text-white mb-6 tracking-wide" style={{ fontSize: '29.5px', fontWeight: 700, WebkitTextStroke: '0.5px' }}>
                VERTA ŽINOTI
              </h2>
              <div className="space-y-2 text-white leading-relaxed">
                <p>
                  Nuomojamas tik visas poilsio kompleksas, išskirtiniais atvejais galime tartis individualiai.
                </p>
                <p>
                  Į nuomos kainą įtrauktos visos pramogos, esančios teritorijoje.
                </p>
                <p>
                  Kainos priklauso nuo sezoniškumo, pasirinkto laiko intervalo, todėl derinamos individualiai.
                </p>
                <p>
                  Propaguojame aktyvų laisvalaikį, todėl galime pasiūlyti ne tik lauko teniso pamokas su profesionaliais treneriais, atletinio rengimo treniruotes, bet ir organizuoti jūsų grupei skirtą turnyrą ar sporto stovyklą.
                </p>
                <p>
                  Skatiname rūpintis emocine sveikata – organizuojame pirčių ritualus, jogos, kvėpavimo meditacijos užsiėmimus, garsų, miško terapijas, iškrovos ir sveikatinimo stovyklas. Galime pasiūlyti profesionalaus pirtininko ir masažisto paslaugas.
                </p>
                <p>
                  Ypatingą dėmesį skiriame maisto kultūrai ir galime pasiūlyti profesionalaus šefo paslaugas užkandžiams konferencijų metu ar išskirtinei vakarienei ant ežero kranto.
                </p>
                <p>
                  Galime pasiūlyti renginio vedėją, DJ ir populiariausių Lietuvos atlikėjų paslaugas, teminius vakarus ir kitas atrakcijas.
                </p>
                <p>
                  Puoselėjame ne tik vienas kitam draugiško elgesio kultūrą, bet ir mus supančiai aplinkai.
                </p>
              </div>
            </div>

            {/* Image - 30% */}
            <div className="lg:col-span-3 relative h-96 lg:h-auto min-h-[400px]">
              <img 
                src="/img/1-2.jpg" 
                alt="Sporto Krantas teritorija"
                className="absolute inset-0 w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="bg-white border-b-[3px] border-black">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <h3 className="text-center text-lg font-semibold text-black mb-6 tracking-wide">
            PARTNERIAI:
          </h3>
          <div className="flex flex-wrap items-center justify-center gap-8 lg:gap-12">
            <a href="https://balzekastennis.lt/" target="_blank" rel="noopener noreferrer" className="h-32 w-56 flex items-center justify-center hover:opacity-80 transition-opacity">
              <img src="/img/partner1.jpg" alt="Balzekas Tennis" className="max-h-full max-w-full object-contain" />
            </a>
            <a href="https://btfitness.lt/lt/" target="_blank" rel="noopener noreferrer" className="h-32 w-56 flex items-center justify-center hover:opacity-80 transition-opacity">
              <img src="/img/partner2.jpg" alt="BT Fitness" className="max-h-full max-w-full object-contain" />
            </a>
            <a href="https://www.m7sport.lt/" target="_blank" rel="noopener noreferrer" className="h-32 w-56 flex items-center justify-center hover:opacity-80 transition-opacity">
              <img src="/img/partner3.jpg" alt="M7 Sport" className="max-h-full max-w-full object-contain" />
            </a>
            <a href="https://www.manoarena.lt/" target="_blank" rel="noopener noreferrer" className="h-32 w-56 flex items-center justify-center hover:opacity-80 transition-opacity">
              <img src="/img/partner4.jpg" alt="Mano Arena" className="max-h-full max-w-full object-contain" />
            </a>
            <a href="https://www.mano.bank/" target="_blank" rel="noopener noreferrer" className="h-32 w-56 flex items-center justify-center hover:opacity-80 transition-opacity">
              <img src="/img/partner5.jpg" alt="Mano Bank" className="max-h-full max-w-full object-contain" />
            </a>
            <a href="https://akvile.lt/" target="_blank" rel="noopener noreferrer" className="h-32 w-56 flex items-center justify-center hover:opacity-80 transition-opacity">
              <img src="/img/partner6.jpg" alt="Akvilė" className="max-h-full max-w-full object-contain" />
            </a>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;
